import { render, staticRenderFns } from "./TableSend.vue?vue&type=template&id=44089171&scoped=true"
import script from "./TableSend.vue?vue&type=script&lang=js"
export * from "./TableSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44089171",
  null
  
)

export default component.exports